







































import { mapGetters } from 'vuex';

import {
  getStreamConfiguration,
  updateStreamConfiguration
} from '@/api/CopyStake/Configuration';
import {
  TStreamConfigurationResponse,
  TStreamConfigurationPayload,
  ValidationRules
} from '@/api/schema';

import { errorToastMessage } from '@/helpers/errorToastMessage';
import * as vr from '@/helpers/validation';
import { cloneDeep } from 'lodash';

export default {
  name: 'CopyStakeWebStreamerSettingsForm',
  data(): any {
    return {
      streamSettingsSavedData: {},
      inactiveTimeout: '',

      isLoading: false,
      formValid: false
    };
  },
  computed: {
    ...mapGetters('Onboarding', ['operatorId']),

    canEdit(): boolean {
      return this.$role.can.update('copy_stake streamers');
    },

    inactivityTimeoutChanged(): boolean {
      return (
        this.inactiveTimeout !==
        this.streamSettingsSavedData?.inactiveTimeout?.webStreamer
      );
    },
    valueCanBeSaved(): boolean {
      return this.formValid && this.inactivityTimeoutChanged;
    },

    rules(): ValidationRules {
      return {
        inactivityTimeoutRules: [
          (v) => v === '' || v === null || vr.positiveNumber(v),
          (v) => v === '' || v === null || vr.validNumber(v),
          (v) => v === '' || v === null || vr.integer(v)
        ]
      };
    }
  },
  watch: {
    operatorId: {
      handler: 'getConfiguration',
      immediate: true
    }
  },
  methods: {
    onInactiveTimeoutInput(val: string | number): void {
      this.inactiveTimeout = this.parseInputValue(val);

      this.validateForm();
    },
    parseInputValue(val: string | number): number | string | null {
      if (val === '') return null;

      const num = Number(val);
      return isNaN(num) ? val : num;
    },

    validateForm(): void {
      this.$nextTick(() => {
        this.$refs.form.validate();
      });
    },

    async getConfiguration(): Promise<void> {
      if (!this.operatorId) {
        return;
      }

      this.isLoading = true;

      getStreamConfiguration()
        .then((data: TStreamConfigurationResponse) => {
          this.parseSettingsData(data);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    async updateConfiguration(): Promise<void> {
      this.isLoading = true;

      const payload: Partial<TStreamConfigurationPayload> = cloneDeep(
        this.streamSettingsSavedData
      );

      if (this.inactivityTimeoutChanged) {
        payload.inactiveTimeout.webStreamer = this.inactiveTimeout;
      }

      await updateStreamConfiguration(payload)
        .then((data: TStreamConfigurationResponse) => {
          this.parseSettingsData(data);

          this.$toast.success('Settings was successfully updated!');
        })
        .catch(errorToastMessage)
        .finally(() => {
          this.isLoading = false;
        });
    },
    parseSettingsData(data: TStreamConfigurationResponse): void {
      this.streamSettingsSavedData = cloneDeep(data);

      this.inactiveTimeout = data.inactiveTimeout?.webStreamer || null;
    }
  }
};
